import { createAction, createSelector, createSlice } from "@reduxjs/toolkit";
import IOTsim from "../IOTsim";

const initialState = {
	apiError: false,
	loading: false,
	IOTSimdetails: {},
	addtoCartResponse:{},
};

const WCMPSlice = createSlice({
	name: "WCMP",
	initialState,
	reducers: {
		resetWCMPSlice: (state) => {
			return initialState;
		},
		setIOTSimdetails:(state, action)=>{			
			state["IOTSimdetails"] = action.payload;
		},
		setAccountdetailsResp:(state, action)=>{			
			state["accountdetailsResp"] = action.payload;
		},
		setAPIError: (state, action) => {
			state["apiError"] = action.payload;
		},
		setPageLoading: (state, action) => {
			state["loading"] = action.payload;
		},
		setAddtoCartResponse:(state,action) => {
            state["addtoCartResponse"] = action.payload;
		},
		setErrorResponse:(state,action) => {
            state["errorResponse"] = action.payload;
		},
		setNotification: (state, action) => {
			state["notification"] = action.payload;
		  },
	    setErrorInfo: (state, action) => {
		    state["errorInfo"] = action.payload;
	     },		
	},
});
//export const accessToShowMarketplace = createAction("BussProductSlice/accessToShowMarketplace");
export const reducer = WCMPSlice.reducer;

// export const addToCart = createAction("BussProductSlice/addToCart");
// export const marketplaceAddToCart = createAction("BussProductSlice/marketplaceAddToCart");
// export const bussGridwall = createAction("BussProductSlice/bussGridwall");
export const getIOTSimdetails = createAction("WCMPSlice/getIOTSimdetails");
export const addIOTSimdetails = createAction("WCMPSlice/addIOTSimdetails");

export const {
    resetWCMPSlice,
	setAPIError,
	setPageLoading,
	setIOTSimdetails,
	setAddtoCartResponse,
	setErrorResponse,
	setErrorInfo,
	setNotification,
	setAccountdetailsResp
} = WCMPSlice.actions;
